import { useQuery } from '@tanstack/react-query';
import { getShareableFlags } from '~/api/featureFlags';

const SHAREABLE_FLAGS_QUERY_KEY = 'shareable-flags';

export const useShareableFlags = (shareToken: string | undefined) =>
  useQuery({
    queryKey: [SHAREABLE_FLAGS_QUERY_KEY, shareToken],
    queryFn: () => getShareableFlags(shareToken!),
    enabled: Boolean(shareToken),
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000 * 5,
    retry: 1,
  });
